export default __webpack_public_path__ + "static/media/map300.a54d17ca.png";